// extracted by mini-css-extract-plugin
module.exports = {"menu-layout":"myAccountMenu_menu-layout__K8nYk","menu-item":"myAccountMenu_menu-item__3Sfy2"};